import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function PermissionGate({
  children,
  adminOnly = false,
  permission,
  anyOf,
  fallback = null,
}) {
  const { isLoading, isResolving, isAdmin, hasPermission } = useAuth();

  if (isLoading || isResolving) return null;

  let allowed = true;
  if (adminOnly) {
    allowed = isAdmin();
  } else if (permission) {
    allowed = hasPermission(permission);
  } else if (Array.isArray(anyOf) && anyOf.length > 0) {
    allowed = anyOf.some((p) => hasPermission(p));
  }

  return allowed ? <>{children}</> : <>{fallback}</>;
}
